// products.jsx
import React from 'react';
import './products.css';
import Sidebar from '../sidebar/sidebar';
import image from "../../assets/Large-screens/6.png"


const Products = () => {
  return (
    <div className="home-container">
      <Sidebar />
      <div className="home-content">
        <img
          src={image} // Replace with your image URL
          alt="Products"
          className="home-image"
        />
      </div>
    </div>
  );
};

export default Products;
